export interface FaqItem {
  pregunta: string;
  respuesta: string;
}

export const faqItems: FaqItem[] = [
  {
    pregunta: '¿Necesito saber cocinar para usar esta guía?',
    respuesta:
      'No. Todas las recetas están pensadas para principiantes. Instrucciones paso a paso, ingredientes simples, tiempos claros. Incluso hay 40 recetas que hacés en menos de 10 minutos. Lo importante es que disfrutes comer bien.'
  },
  {
    pregunta: '¿Los ingredientes son fáciles de conseguir en España?',
    respuesta:
      'Sí, 100%. Todas las recetas usan ingredientes del supermercado español. Sin cosas raras, caras ni imposibles de encontrar. La idea es que sea práctico y accesible para el día a día.'
  },
  {
    pregunta: '¿Cuándo recibo acceso después de comprar?',
    respuesta:
      'Inmediato. En menos de 2 minutos recibes un email con el link de descarga. Todo en PDF de alta calidad. Lo guardás, lo descargas, lo llevás donde quieras. Funciona en tablet, móvil y computadora.'
  },
  {
    pregunta: '¿Hay garantía si no quedo conforme?',
    respuesta:
      'Sí, garantía de 7 días: si tienes problemas para acceder al material, falta alguno de los contenidos anunciados o lo recibido no corresponde con la oferta mostrada en esta página, escríbenos a manualeslistos@gmail.com y lo resolveremos.'
  },
  {
    pregunta: '¿En cuánto tiempo noto cambios?',
    respuesta:
      'Muchas pacientes sienten la diferencia en 4-7 días. La mayoría nota un cambio claro en 2-3 semanas. A las 12 semanas ves una transformación real, tanto en datos como en cómo te sentís. Con el Diario de Síntomas tenés el rastreo exacto.'
  },
  {
    pregunta: '¿Si tengo intolerancias o alergias, funciona igual?',
    respuesta:
      'Sí. El Bono 3 (La Biblia de los Reemplazos) tiene secciones especiales: sin gluten con opciones en cada receta, sin lácteos con alternativas claras, sin huevo con sustitutos probados, y recetas específicamente diseñadas para colon irritable.'
  },
  {
    pregunta: '¿Necesito comprar suplementos o productos especiales?',
    respuesta:
      'No. Todas las recetas usan alimentos normales del supermercado. Sin batidos especiales, sin suplementos carísimos, sin polvos mágicos. Es comida real que te desinfla de verdad.'
  }
];
